export default __webpack_public_path__ + "static/drinks-dispense-585ca8021acd2247105aaca4142b622f.png";